import { isoDate } from './date';
export var TermsVersion;
(function (TermsVersion) {
    TermsVersion["ExistingClient"] = "existing_client";
    TermsVersion["NewClient"] = "new_client";
})(TermsVersion || (TermsVersion = {}));
/**
 * Data wdrożenia funkcji akceptacji regulaminu.
 * Użytkownicy zarejestrowani przed tą datą dostają klauzulę dla obecnych klientów.
 */
export const TERMS_DEPLOYMENT_DATE = isoDate('2026-03-31');
export class UserConsent {
    constructor(data) {
        this.registeredAt = data.registeredAt;
        this.acceptedAt = data.acceptedAt;
    }
    get requiresConsent() {
        return this.acceptedAt === null;
    }
    get requiredVersion() {
        return this.registeredAt < TERMS_DEPLOYMENT_DATE
            ? TermsVersion.ExistingClient
            : TermsVersion.NewClient;
    }
}
//# sourceMappingURL=user-consent.js.map